import * as R from 'ramda'
import moment from 'moment'
import Numeral from 'numeral'
import createSelector from 'utils/redux/createSelector' // import { createSelector } from 'reselect'
import { transactionTypeMeta } from 'helpers/accounting'
import { tenants, leases, transactions } from './entities'
import { tenantsByHouseholdID, transactionsByPropertyID, transactionsByTenantID } from './index'
import { sort, makePropSelector } from './common'
import { commentsByObjectID } from './index'
import { attachmentsByObjectID } from './attachments'
import { filteredCollection } from './filters'
import { createSearchAction, getSearchSelectors } from 'redux-search'

export let parents = createSelector(
	tenants
  , tenants => R.filter(tenant => !tenant.parentID)(tenants)
)

export let household = createSelector(
	[tenants, makePropSelector('objectID')]
  , (tenants, objectID) => R.filter(tenant => tenant.parentID === objectID)(tenants)
)

// TODO: do we need it?
export let tenantsProperty = createSelector(
	leases
  , leases => {
		let tenantsProperty = {}
		R.map(lease=> {
			tenantsProperty[lease.tenantID] = {propertyID: lease.propertyID || lease.property}
		})(leases)
		return tenantsProperty
	}
)

export let depositByTenantID = createSelector(
	[transactionsByTenantID]
  , (transactionsByTenantID) => {
  		return R.map(transactions => {
			let deposit = 0
			R.forEach(transaction => {
				if (transaction.type == 'transaction/invoice') {
					R.forEach(line => {
						if (line.category == "Deposit") {
							deposit += +line.amount
						}
					})(transaction.lines)
				}
			})(transactions)
			return deposit
		})(transactionsByTenantID)
	}
  , 'depositByTenantID'
)

// TODO: unite with transactionsEx
export let ledgerByTenantID = createSelector(
	[tenants, transactionsByTenantID, depositByTenantID]
  , (tenants, transactionsByTenantID, depositByTenantID) => {
  		return R.map(tenant => {
	  		let transactions = transactionsByTenantID[tenant._id]
	  		let deposit = depositByTenantID[tenant._id]
			let invoices = 0
			let payments = 0
			let refund = 0
			let ledger = []
			R.forEach(transaction => {
				if (transaction.type == 'transaction/invoice') {
					R.forEach(line => {
						if (line.category != "Deposit") {
							invoices += +line.amount
						}
						let balance = invoices - payments + deposit
						let amount = +line.amount || 0
						ledger.push({
							...transaction
						  , debit: amount
						  , balance
						  , deposit
						  , refund
						  , named: { name: line.category + ' charge', memo: line.memo }
						})
					})(transaction.lines)
				} else if (transaction.type !== 'transaction/bill') {
					let meta = transactionTypeMeta[transaction.type]
					let amount = (+transaction.amount * meta.payments) || 0
					payments += amount
					if (transaction.type == 'transaction/deposit-refund') {
						refund += +transaction.amount
					}

					let balance = invoices - payments + deposit
					if(balance.toFixed(2) == 0){
						balance = 0;
					}
					ledger.push({
						...transaction
					  , payments
					  , refund
					  , balance
					  , сredit: +transaction.amount
					  , deposit
					  , named: { name: meta.named }
					})
				}
			})(transactions)

			return R.reverse(ledger)
	 	})(tenants)
	}
  , 'ledgerByTenantID'
)

export let tenantLedger = createSelector(
	[ledgerByTenantID, makePropSelector('tenantID')]
  , (ledgerByTenantID, tenantID) => {
		return ledgerByTenantID[tenantID] || []
	}
)

export let householdTenants = createSelector(
		[tenants, tenantsByHouseholdID, makePropSelector('objectID')]
  , (tenants, tenantsByHouseholdID, tenantID) => {
		let tenant = tenants[tenantID] || {_id: tenantID}
		return tenantsByHouseholdID[tenant.parentID || tenant._id] || []
	}
)

export let tenantsEx = createSelector(
	[filteredCollection('tenant'), ledgerByTenantID, commentsByObjectID, attachmentsByObjectID, sort('tenant', {secondary: 'phone'})]
  ,	(tenants, ledgerByTenantID, commentsByObjectID, attachmentsByObjectID, sort) => {
    	let extend = tenant => {
			let lastTransaction = ledgerByTenantID[tenant._id][0]
			let balance = lastTransaction && lastTransaction.balance
			return {
				...tenant
			  , balance: balance || 0
			  , number: tenant.phoneNumber && tenant.phoneNumber.match(/[0-9]/g) && tenant.phoneNumber.match(/[0-9]/g).join('') || ''
			  , comments: commentsByObjectID[tenant._id] || []
			  , attachments: attachmentsByObjectID[tenant._id] || []
			  , tenant: tenant.tenant || tenant.firstName + ' ' + tenant.lastName
			  , id: tenant._id
	  		}
		}
		return R.pipe(R.map(extend),  R.filter(x=>x)/*, sort.fn*/)(tenants)
	}
  , 'tenantsEx'
)

let {
	text
  , result //  ids
  , unfilteredResult
} = getSearchSelectors({
	resourceName: 'tenant'
  , resourceSelector: (resourceName, state) => tenantsEx(state)
})

export let tenantsTable = createSelector(
	[tenantsEx, text, result, unfilteredResult, sort('tenant', {secondary: 'phone'})],
	(tenantsEx, text, result, unfilteredResult, sort) => {
		if (text) {
			tenantsEx = R.filter(x => x)(R.map(id => tenantsEx[id], unfilteredResult))
		}
		return sort.fn(tenantsEx)
 	}
 )

export let deposit = createSelector(
	[depositByTenantID, makePropSelector('tenantID')]
  , (depositByTenantID, tenantID) => depositByTenantID[tenantID]
)



// WEBPACK FOOTER //
// ./src/selectors/tenant.js